var _path, _path2, _ellipse, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraintegrationaccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 126,
    viewBox: "0 0 87 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 121H39C52.2548 121 63 110.255 63 97V0",
    stroke: "#D9EDFC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1656e-07 126C1.32608 126 2.59785 125.473 3.53553 124.536C4.47322 123.598 5 122.326 5 121C5 119.674 4.47322 118.402 3.53553 117.464C2.59785 116.527 1.32608 116 1.90735e-06 116L7.35117e-07 121L5.1656e-07 126Z",
    fill: "#D9EDFC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63,
    cy: 59,
    rx: 21,
    ry: 21,
    transform: "rotate(-90 63 59)",
    fill: "#ACDAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1218 65H56.6802C55.7527 65 55 64.2473 55 63.3198V54.6802C55 53.7527 55.7527 53 56.6802 53H64.1218C65.0493 53 65.802 53.7527 65.802 54.6802V63.3215C65.802 64.249 65.0493 65 64.1218 65Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8022 57.8004L69.1559 54.4467C69.3139 54.2888 69.5273 54.2014 69.7507 54.2014H70.9621C71.4259 54.2014 71.8022 54.5778 71.8022 55.0415V62.962C71.8022 63.4257 71.4259 63.8021 70.9621 63.8021H69.7507C69.5273 63.8021 69.3139 63.713 69.1559 63.5568L65.8022 60.2031",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 46.5,
    r: 6.5,
    fill: "#55B9FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8237 46.5H83.1767",
    stroke: "white",
    strokeWidth: 0.764706
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 43.8236L80.5 49.1765",
    stroke: "white",
    strokeWidth: 0.764706
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraintegrationaccess);
export default __webpack_public_path__ + "static/media/cameraintegrationaccess.203d95476bbb69387b758f194a08dafb.svg";
export { ForwardRef as ReactComponent };